import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, FixedDropDownButton, Icon, modal, utils, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
import * as subjektActions from "../actions/subjektActions";
import UzivatelForm from "../forms/UzivatelForm";
import ZmenaHeslaForm from "../forms/ZmenaHeslaForm";
import OpravneniApi from "../api/gen/cgo/OpravneniApi";
import {toastr} from "react-redux-toastr";
import * as opravneniActions from "../actions/opravneniActions";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující základní údaje o uživateli.
 */
class UzivatelZakladniUdajePanel extends Component<WithTranslation> {

    static propTypes = {
        uzivatel: PropTypes.object.isRequired, // VO uživatele
        readOnly: PropTypes.bool, // zda nezobrazit tlačítka pro editaci a změnu hesla, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
    };

    handleEditUzivatel = () => {
        const {loggedInUser, uzivatel, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UzivatelForm,
            {
                onSubmit: (data) => {
                    return subjektActions.updateUzivatel(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatelDetail(uzivatel.id));
                    if (loggedInUser.data.id === uzivatel.id) {
                        dispatch(opravneniActions.invalidateLoggedInUser());
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: uzivatel
            },
            t('user.edit'),
            {size: "md"}
        ));
    };

    handleEditUzivatelHeslo = () => {
        const {uzivatel, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZmenaHeslaForm,
            {
                onSubmit: (data) => {
                    OpravneniApi.changePassword(uzivatel.id, data.oldPassword, data.password).then(() => {
                        toastr.success(t('password_changed'));
                    });
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('user.password.edit', {user: uzivatel.zobrazJmeno}),
            {size: "md"}
        ));
    };

    handleResetUzivatelHeslo = () => {
        const {uzivatel, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('password_reset'),
                t('user.password.reset', {user: uzivatel.zobrazJmeno}),
                () => {
                    OpravneniApi.resetPassword(uzivatel.id).then(() => {
                        toastr.success(t('password_reset_done'));
                    });
                },
                null,
                t('confirm')
            )
        );
    };

    renderActions = () => {
        const {readOnly, t} = this.props;
        return <ButtonToolbar>
            {!readOnly && <Button onClick={this.handleEditUzivatel}>{t('edit')}</Button>}
            {!readOnly && <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v"/>}>
                <DropdownItem key="0" onClick={this.handleEditUzivatelHeslo}>{t('user.password.edit.action')}</DropdownItem>
                <DropdownItem key="1" onClick={this.handleResetUzivatelHeslo}>{t('user.password.reset.action')}</DropdownItem>
            </FixedDropDownButton>}
        </ButtonToolbar>
    };

    render() {
        const {loggedInUser, uzivatel, t} = this.props;

        if (!loggedInUser.fetched) {
            return <Loader/>;
        }

        return <Card>
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('basic_details')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('title_before')}>{uzivatel.titulPr}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('firstname')}>{uzivatel.jmeno}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('surname')}>{uzivatel.prijmeni}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('title_after')}>{uzivatel.titulZa}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('phone')}>{uzivatel.telefon}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('email')}>{uzivatel.email}</DetailValue>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(UzivatelZakladniUdajePanel));
